module.exports = __webpack_public_path__ + "img/06_a.d07d14ad.webp";